import React, { useState, useContext, useEffect } from "react";
import { useRouter } from "next/router";
import striptags from "striptags";
import ReactHtmlParser from "react-html-parser";
import * as S from "./Article.sc";
import ArticleContent from "./ArticleContent";
import ArticleHideContent from "./ArticleHideContent";
import Author from "./Author";

import ArticleLegalAdvice from "../ArticleLegalAdvice/ArticleLegalAdvice";
import ArticleTitle from "../ArticleTitle/ArticleTitle";
import { replaceDomainToTap } from "../../services/urlString";
import { getArticleDataByPages } from "../../services/wysiwyg-article";
import Documents from "../Documents/Documents";
import { passedMoreThanHalfYear } from "../../services/date";
import { reloadArticle } from "../../services/serverSideRequests";
import { UserContext } from "../../context/UserContext";

const Article = ({ article, authors, video }) => {
  const [content, setContent] = useState(article);
  const { query } = useRouter();
  const strona = query.strona || 1;
  const articleData = getArticleDataByPages(content.body_split);
  const [user] = useContext(UserContext);
  useEffect(() => {
    setContent(article);
  }, [article]);
  useEffect(() => {
    const reload = async (token) => {
      if (token) {
        const data = await reloadArticle(query.article, token);
        if (data) {
          setContent(data[0]);
        }
      }
    };
    reload(user.token);
  }, [user]);
  const hasAccess = true;
  const croppedImage = content.crops.find((el) => el.ratio === "400x200");
  // const hasAccess = content.has_access || article.body_split.length === 1;
  return (
    <div>
      <ArticleTitle
        article={content}
        showShareButtons={true}
        authors={authors}
      />
      {content.can_expire && passedMoreThanHalfYear(content.published_at) && (
        <S.InfoText>
          Od publikacji artykułu minęło już trochę czasu, upewnij się, czy nie
          zmienił się stan prawny
        </S.InfoText>
      )}
      {video && (
        <S.Video controls>
          <source src={video.movie} type="video/mp4" poster={video.thumbnail} />
          Your browser does not support the video tag.
        </S.Video>
      )}
      <S.Row>
        {content.image_cropped && !video && (
          <S.ImgContainer>
            <S.MainImage
              src={replaceDomainToTap(
                croppedImage?.image || content.image_cropped
              )}
            />
          </S.ImgContainer>
        )}

        <S.Lead fullWidth={video !== null}>{striptags(content.lead)}</S.Lead>
      </S.Row>
      {hasAccess ? (
        <ArticleContent
          article={articleData}
          site={strona}
          id={content.id}
          topics={content.topics_covered}
          tableOfContentData={content.table_of_contents}
        />
      ) : (
        <ArticleHideContent
          article={content}
          topics={content.topics_covered}
          tableOfContentData={content.table_of_contents}
        />
      )}

      {content.files.length > 0 && <Documents files={content.files} />}
      {authors &&
        authors.map((author) => (
          <Author key={`author${author.id}`} author={author} />
        ))}
      <ArticleLegalAdvice />
    </div>
  );
};

export default Article;
